import { createAction, props } from '@ngrx/store';

import { ProductBoxRegistration } from 'app/shared/components/product-box/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { Container } from 'app/shared/features/container-selector/models';
import { Locations } from 'app/shared/features/location-selector/models';

import { ManualFlowRegistrationData } from './manual-flow.reducer';
import { ComponentState } from './select-state';

export const initManualFlow = createAction('[ManualFlow] Initialize');

export const initManualFlowSuccess = createAction('[ManualFlow] Initialization Success');

export const updateManualFlowRegistrationDataInStorage = createAction(
    '[ManualFlow] Update Scan Flow Registration Data In Storage',
    props<ManualFlowRegistrationData>(),
);

export const applyManualFlowRegistrationDataFromStorage = createAction(
    '[ManualFlow] Apply Registration Data From Storage',
    props<{
        registrationDataFromStorage: ManualFlowRegistrationData | undefined;
    }>(),
);

export const resetManualFlowRegistrationData = createAction(
    '[ManualFlow] Reset Registration Data',
    (resetBatch = false) => ({ resetBatch }),
);

export const selectActivityInManualFlow = createAction('[ManualFlow] Select Activity In Flow');

export const setActivityInManualFlow = createAction(
    '[ManualFlow] Set Activity In Flow',
    props<{
        activity: Activity;
    }>(),
);

export const setManualFlowComponentState = createAction(
    '[ManualFlow] Set Component State In Flow',
    props<{ componentState: ComponentState }>(),
);

export const manualFlowComponentStateUpdated = createAction('[ManualFlow] Component State In Flow Updated');

export const setLocationInManualFlow = createAction('[ManualFlow] Set Location In Flow', props<Locations>());

export const setBatchInManualFlow = createAction(
    '[ManualFlow] Set Batch In Flow',
    props<{
        batchNumber: number;
    }>(),
);

export const setRowInManualFlow = createAction('[ManualFlow] Set Row In Flow');

export const setEmployeeInManualFlow = createAction(
    '[ManualFlow] Set employee In Flow',
    props<{ employeeNumber: number }>(),
);

export const setContainerInManualFlow = createAction(
    '[ManualFlow] Set container In Flow',
    props<{ containerList: Container[] }>(),
);

export const setAmountResultInManualFlow = createAction(
    '[ManualFlow] Set Amount Result In Flow',
    props<{ amountResult: number | undefined }>(),
);

export const setAmountAndProductBoxInManualFlow = createAction(
    '[ManualFlow] Set Amount Result and Product Box In Flow',
    props<{ updatedProductBoxRegistrations: ProductBoxRegistration[] }>(),
);

export const setProductBoxInManualFlow = createAction(
    '[ManualFlow] Set Product Box In Flow',
    props<{ updatedProductBoxRegistrations: ProductBoxRegistration[] }>(),
);

export const createRegistrationInManualFlow = createAction('[ManualFlow] Create Registration In Flow');

export const goBackInManualFlow = createAction('[ManualFlow] Go to previous state');
